import { memo, useMemo } from 'react';

import { KeyboardIcon } from '@air/design-icons';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';
import { useAirModal } from '@air/provider-modal';

import { KeyboardShortcutsInfoModal } from '~/components/AssetModalV2/Content/Footer/components/KeyboardShortcuts/KeyboardShortcutsInfoModal';
import { OptionsMenu } from '~/components/AssetModalV2/Header/components/OptionsMenu';

export const PublicOptionsMenu = memo(() => {
  const [showKeyboardShortcutsInfoModal] = useAirModal(KeyboardShortcutsInfoModal);

  const options = useMemo<DropdownMenuOption[]>(() => {
    const _options: DropdownMenuOption[] = [];

    _options.push({
      id: 'keyboard-shortcuts-info',
      label: 'Keyboard shortcuts',
      prefix: <KeyboardIcon size="sm" />,
      onSelect: () => {
        showKeyboardShortcutsInfoModal();
      },
      type: 'item',
    });

    return _options;
  }, [showKeyboardShortcutsInfoModal]);

  return <OptionsMenu options={options} />;
});

PublicOptionsMenu.displayName = 'PublicOptionsMenu';
